(() => {
  const dialog = document.getElementById('pm-treat-dialog');
  if (!dialog || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const canvas = dialog.querySelector('canvas');
  const prize = dialog.querySelector('[data-treat-prize]');
  const revealButton = dialog.querySelector('[data-treat-reveal]');
  const reward = dialog.querySelector('[data-treat-reward]');
  const status = dialog.querySelector('[data-treat-status]');
  const codeButton = dialog.querySelector('[data-treat-copy]');
  const terms = dialog.querySelector('#pm-treat-terms');
  const bone = new Path2D('M75 35H225C236 10 264 8 278 22C293 38 289 58 272 70C289 82 293 102 278 118C264 132 236 130 225 105H75C64 130 36 132 22 118C7 102 11 82 28 70C11 58 7 38 22 22C36 8 64 10 75 35Z');
  let shownThisPage = false;
  let ctx, scratching = false, lastPoint = null, revealed = false, samples = [], autoTimer, opener;
  const storage = {
    get(key) { try { return sessionStorage.getItem(key); } catch { return null; } },
    set(key, value) { try { sessionStorage.setItem(key, value); } catch {} }
  };
  function reveal() {
    if (revealed) return;
    revealed = true;
    scratching = false;
    canvas.hidden = true;
    prize.hidden = false;
    revealButton.hidden = true;
    reward.hidden = false;
    terms.textContent = dialog.dataset.termsRevealed;
    terms.hidden = false;
    status.textContent = dialog.dataset.revealed;
  }
  function draw() {
    if (revealed) return;
    const box = canvas.getBoundingClientRect();
    if (!box.width || !box.height) return;
    const ratio = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(box.width * ratio);
    canvas.height = Math.round(box.height * ratio);
    ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (!ctx) return;
    ctx.setTransform(canvas.width / 300, 0, 0, canvas.height / 140, 0, 0);
    ctx.fillStyle = '#f6e7cb';
    ctx.fill(bone);
    ctx.strokeStyle = '#620a22'; ctx.lineWidth = 1.8; ctx.stroke(bone);
    ctx.fillStyle = '#620a22'; ctx.textAlign = 'center'; ctx.font = '600 18px Georgia, serif';
    ctx.fillText(dialog.dataset.scratch, 150, 64);
    ctx.font = 'italic 22px Georgia, serif';
    ctx.fillText(dialog.dataset.scratchSecond, 150, 89);
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
    const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    samples = [];
    for (let i = 3; i < pixels.length; i += 64) if (pixels[i] > 128) samples.push(i);
    ctx.globalCompositeOperation = 'destination-out';
    ctx.lineWidth = 42; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
  }
  function point(event) { const box = canvas.getBoundingClientRect(); return { x: event.clientX - box.left, y: event.clientY - box.top }; }
  function erase(event) {
    if (!scratching || !ctx || revealed) return;
    const next = point(event);
    ctx.beginPath(); ctx.moveTo(lastPoint.x, lastPoint.y); ctx.lineTo(next.x, next.y); ctx.stroke();
    ctx.beginPath(); ctx.arc(next.x, next.y, 21, 0, Math.PI * 2); ctx.fill();
    lastPoint = next;
  }
  function checkProgress() {
    if (!ctx || revealed || !samples.length) return;
    const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    let clear = 0;
    for (const i of samples) if (pixels[i] < 128) clear++;
    if (clear / samples.length > .32) reveal();
  }
  canvas.addEventListener('pointerdown', event => {
    if (revealed || !ctx) return;
    scratching = true; lastPoint = point(event); canvas.setPointerCapture(event.pointerId);
    prize.hidden = false;
    erase(event);
  });
  canvas.addEventListener('pointermove', erase);
  for (const type of ['pointerup', 'pointercancel', 'lostpointercapture']) canvas.addEventListener(type, () => { scratching = false; checkProgress(); });
  function open() {
    opener = document.activeElement;
    if (typeof dialog.showModal !== 'function') return;
    if (!dialog.open) dialog.showModal();
    shownThisPage = true;
    storage.set('permiu_treat_bone_seen', '1');
    clearTimeout(autoTimer);
    draw();
  }
  function close() { dialog.close(); if (opener) opener.focus(); }
  dialog.querySelector('[data-treat-close]').addEventListener('click', close);
  dialog.addEventListener('click', event => { const box = dialog.getBoundingClientRect(); if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) close(); });
  revealButton.addEventListener('click', () => { reveal(); codeButton.focus(); });
  codeButton.addEventListener('click', async () => {
    try { await navigator.clipboard.writeText(dialog.dataset.code); status.textContent = dialog.dataset.copied; }
    catch { status.textContent = dialog.dataset.copyFallback + ' ' + dialog.dataset.code; }
  });
  window.addEventListener('resize', () => { if (dialog.open && !revealed) { prize.hidden = true; draw(); } });
  function maybeOpen() {
    clearTimeout(autoTimer);
    if (shownThisPage || storage.get('permiu_treat_bone_seen') || document.documentElement.classList.contains('shopify-design-mode')) return;
    const blocked = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], #shopify-pc__banner')).some(element => element !== dialog && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).opacity !== '0');
    if (document.visibilityState === 'visible' && !blocked) open();
    else autoTimer = setTimeout(maybeOpen, 5000);
  }
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible' && !shownThisPage && !storage.get('permiu_treat_bone_seen')) { clearTimeout(autoTimer); autoTimer = setTimeout(maybeOpen, 1500); } });
  autoTimer = setTimeout(maybeOpen, 1500);
})();
